import { createContext } from 'react';

export const UserImpersonationContext = createContext({
    impersonationUserId: 0,
    impersonationUsername: '',
    setImpersonationUserDetails: (id: number, username: string) : void => { console.log('dismiss', id, username); },
});
